module.exports = __webpack_public_path__ + "img/material_boat.5212a8f6.svg";